import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import Toggle from 'react-toggle';

class CertificationGroupsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.certification_id,
      name: this.props.certification_group_data.name,
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(this.state.loaded === 0 && typeof newProps.certification_group_data.name !== 'undefined') {
      this.setState({
        id: newProps.certification_group_data.id,
        name: newProps.certification_group_data.name,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/agrupamento/certificados', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
    <form onSubmit={this.edit}>
      <div className="row">
        <div className="col-md-12 form-group">
            <label>Nome:</label>
            <input type="text" name="name" className="form-control" placeholder="Nome do agrupamento" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <hr/>
      <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Editar agrupamento</button>
    </form>
</div>
    );
  }
}

export default CertificationGroupsEditTab;



// WEBPACK FOOTER //
// ./src/Components/CertificationGroups/Elements/CertificationGroupsEditTab.js